import { hasDataAvailable } from '../../../../redux/modules/annotation/helpers';
import { Annotation } from '../../../../types/annotation';

export type NoAccessReason =
  | null
  | 'restrictedAccess'
  | 'deleted'
  | 'importing'
  | 'failedImport';

export const resolveNoAccessReason = (
  annotation: Annotation | undefined
): NoAccessReason => {
  if (
    !annotation ||
    hasDataAvailable({
      status: annotation.status,
      pages: annotation.pages,
      restrictedAccess: annotation.restrictedAccess,
    })
  ) {
    return null;
  }

  if (annotation.restrictedAccess) {
    return 'restrictedAccess';
  }

  if (annotation.status === 'failed_import') {
    return 'failedImport';
  }

  if (annotation.status === 'importing' || annotation.status === 'deleted') {
    return annotation.status;
  }

  return null;
};
